var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"mobile_classify"}},[_c('StartAndEnd',[_c('div',[_c('ClassList',{attrs:{"gameTypeList":_vm.gameTypeList,"topList":_vm.topList,"bottomList":_vm.bottomList,"from":"1"}}),_c('BottomList'),_c('BottomText')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }